/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * train-with-me
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetTrainerAvailabilityParams,
  MicrosoftAspNetCoreMvcProblemDetails,
  TrainWithMeModulesBookingDtosRequestsPostBlockRequest,
  TrainWithMeModulesBookingDtosRequestsPutDateOverrideRequest,
  TrainWithMeModulesBookingDtosRequestsPutWeeklyWindowsRequest,
  TrainWithMeModulesBookingDtosResponsesBlockResponse,
  TrainWithMeModulesBookingDtosResponsesTrainerAvailabilityResponse
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType , BodyType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getTrainerAvailability = (
    params?: GetTrainerAvailabilityParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesBookingDtosResponsesTrainerAvailabilityResponse>(
      {url: `/trainer-availability`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetTrainerAvailabilityQueryKey = (params?: GetTrainerAvailabilityParams,) => {
    return [
    `/trainer-availability`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTrainerAvailabilityQueryOptions = <TData = Awaited<ReturnType<typeof getTrainerAvailability>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(params?: GetTrainerAvailabilityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrainerAvailability>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTrainerAvailabilityQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTrainerAvailability>>> = ({ signal }) => getTrainerAvailability(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTrainerAvailability>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTrainerAvailabilityQueryResult = NonNullable<Awaited<ReturnType<typeof getTrainerAvailability>>>
export type GetTrainerAvailabilityQueryError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>


export function useGetTrainerAvailability<TData = Awaited<ReturnType<typeof getTrainerAvailability>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 params: undefined |  GetTrainerAvailabilityParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrainerAvailability>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTrainerAvailability>>,
          TError,
          Awaited<ReturnType<typeof getTrainerAvailability>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTrainerAvailability<TData = Awaited<ReturnType<typeof getTrainerAvailability>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 params?: GetTrainerAvailabilityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrainerAvailability>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTrainerAvailability>>,
          TError,
          Awaited<ReturnType<typeof getTrainerAvailability>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTrainerAvailability<TData = Awaited<ReturnType<typeof getTrainerAvailability>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 params?: GetTrainerAvailabilityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrainerAvailability>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTrainerAvailability<TData = Awaited<ReturnType<typeof getTrainerAvailability>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 params?: GetTrainerAvailabilityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrainerAvailability>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTrainerAvailabilityQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postTrainerAvailabilityBlock = (
    trainWithMeModulesBookingDtosRequestsPostBlockRequest?: BodyType<TrainWithMeModulesBookingDtosRequestsPostBlockRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesBookingDtosResponsesBlockResponse>(
      {url: `/trainer-availability/block`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesBookingDtosRequestsPostBlockRequest, signal
    },
      options);
    }




export const getPostTrainerAvailabilityBlockMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTrainerAvailabilityBlock>>, TError,{data?: BodyType<TrainWithMeModulesBookingDtosRequestsPostBlockRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postTrainerAvailabilityBlock>>, TError,{data?: BodyType<TrainWithMeModulesBookingDtosRequestsPostBlockRequest>}, TContext> => {

const mutationKey = ['postTrainerAvailabilityBlock'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTrainerAvailabilityBlock>>, {data?: BodyType<TrainWithMeModulesBookingDtosRequestsPostBlockRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postTrainerAvailabilityBlock(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostTrainerAvailabilityBlockMutationResult = NonNullable<Awaited<ReturnType<typeof postTrainerAvailabilityBlock>>>
    export type PostTrainerAvailabilityBlockMutationBody = BodyType<TrainWithMeModulesBookingDtosRequestsPostBlockRequest> | undefined
    export type PostTrainerAvailabilityBlockMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePostTrainerAvailabilityBlock = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTrainerAvailabilityBlock>>, TError,{data?: BodyType<TrainWithMeModulesBookingDtosRequestsPostBlockRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postTrainerAvailabilityBlock>>,
        TError,
        {data?: BodyType<TrainWithMeModulesBookingDtosRequestsPostBlockRequest>},
        TContext
      > => {
      return useMutation(getPostTrainerAvailabilityBlockMutationOptions(options), queryClient);
    }
    export const deleteTrainerAvailabilityBlockId = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/trainer-availability/block/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteTrainerAvailabilityBlockIdMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTrainerAvailabilityBlockId>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTrainerAvailabilityBlockId>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteTrainerAvailabilityBlockId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTrainerAvailabilityBlockId>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteTrainerAvailabilityBlockId(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTrainerAvailabilityBlockIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTrainerAvailabilityBlockId>>>

    export type DeleteTrainerAvailabilityBlockIdMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const useDeleteTrainerAvailabilityBlockId = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTrainerAvailabilityBlockId>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteTrainerAvailabilityBlockId>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteTrainerAvailabilityBlockIdMutationOptions(options), queryClient);
    }
    export const deleteTrainerAvailabilityOverrideDate = (
    date: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/trainer-availability/override/${date}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteTrainerAvailabilityOverrideDateMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTrainerAvailabilityOverrideDate>>, TError,{date: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTrainerAvailabilityOverrideDate>>, TError,{date: string}, TContext> => {

const mutationKey = ['deleteTrainerAvailabilityOverrideDate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTrainerAvailabilityOverrideDate>>, {date: string}> = (props) => {
          const {date} = props ?? {};

          return  deleteTrainerAvailabilityOverrideDate(date,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTrainerAvailabilityOverrideDateMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTrainerAvailabilityOverrideDate>>>

    export type DeleteTrainerAvailabilityOverrideDateMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const useDeleteTrainerAvailabilityOverrideDate = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTrainerAvailabilityOverrideDate>>, TError,{date: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteTrainerAvailabilityOverrideDate>>,
        TError,
        {date: string},
        TContext
      > => {
      return useMutation(getDeleteTrainerAvailabilityOverrideDateMutationOptions(options), queryClient);
    }
    export const putTrainerAvailabilityOverrideDate = (
    date: string,
    trainWithMeModulesBookingDtosRequestsPutDateOverrideRequest?: BodyType<TrainWithMeModulesBookingDtosRequestsPutDateOverrideRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/trainer-availability/override/${date}`, method: 'PUT',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesBookingDtosRequestsPutDateOverrideRequest, signal
    },
      options);
    }




export const getPutTrainerAvailabilityOverrideDateMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTrainerAvailabilityOverrideDate>>, TError,{date: string;data?: BodyType<TrainWithMeModulesBookingDtosRequestsPutDateOverrideRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putTrainerAvailabilityOverrideDate>>, TError,{date: string;data?: BodyType<TrainWithMeModulesBookingDtosRequestsPutDateOverrideRequest>}, TContext> => {

const mutationKey = ['putTrainerAvailabilityOverrideDate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putTrainerAvailabilityOverrideDate>>, {date: string;data?: BodyType<TrainWithMeModulesBookingDtosRequestsPutDateOverrideRequest>}> = (props) => {
          const {date,data} = props ?? {};

          return  putTrainerAvailabilityOverrideDate(date,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutTrainerAvailabilityOverrideDateMutationResult = NonNullable<Awaited<ReturnType<typeof putTrainerAvailabilityOverrideDate>>>
    export type PutTrainerAvailabilityOverrideDateMutationBody = BodyType<TrainWithMeModulesBookingDtosRequestsPutDateOverrideRequest> | undefined
    export type PutTrainerAvailabilityOverrideDateMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePutTrainerAvailabilityOverrideDate = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTrainerAvailabilityOverrideDate>>, TError,{date: string;data?: BodyType<TrainWithMeModulesBookingDtosRequestsPutDateOverrideRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putTrainerAvailabilityOverrideDate>>,
        TError,
        {date: string;data?: BodyType<TrainWithMeModulesBookingDtosRequestsPutDateOverrideRequest>},
        TContext
      > => {
      return useMutation(getPutTrainerAvailabilityOverrideDateMutationOptions(options), queryClient);
    }
    export const putTrainerAvailabilityWeekly = (
    trainWithMeModulesBookingDtosRequestsPutWeeklyWindowsRequest?: BodyType<TrainWithMeModulesBookingDtosRequestsPutWeeklyWindowsRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/trainer-availability/weekly`, method: 'PUT',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesBookingDtosRequestsPutWeeklyWindowsRequest, signal
    },
      options);
    }




export const getPutTrainerAvailabilityWeeklyMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTrainerAvailabilityWeekly>>, TError,{data?: BodyType<TrainWithMeModulesBookingDtosRequestsPutWeeklyWindowsRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putTrainerAvailabilityWeekly>>, TError,{data?: BodyType<TrainWithMeModulesBookingDtosRequestsPutWeeklyWindowsRequest>}, TContext> => {

const mutationKey = ['putTrainerAvailabilityWeekly'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putTrainerAvailabilityWeekly>>, {data?: BodyType<TrainWithMeModulesBookingDtosRequestsPutWeeklyWindowsRequest>}> = (props) => {
          const {data} = props ?? {};

          return  putTrainerAvailabilityWeekly(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutTrainerAvailabilityWeeklyMutationResult = NonNullable<Awaited<ReturnType<typeof putTrainerAvailabilityWeekly>>>
    export type PutTrainerAvailabilityWeeklyMutationBody = BodyType<TrainWithMeModulesBookingDtosRequestsPutWeeklyWindowsRequest> | undefined
    export type PutTrainerAvailabilityWeeklyMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePutTrainerAvailabilityWeekly = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTrainerAvailabilityWeekly>>, TError,{data?: BodyType<TrainWithMeModulesBookingDtosRequestsPutWeeklyWindowsRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putTrainerAvailabilityWeekly>>,
        TError,
        {data?: BodyType<TrainWithMeModulesBookingDtosRequestsPutWeeklyWindowsRequest>},
        TContext
      > => {
      return useMutation(getPutTrainerAvailabilityWeeklyMutationOptions(options), queryClient);
    }
